import {useState} from "react";
import {useTranslation} from "react-i18next";
import {TABS_FA} from "../Model/Model";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 04 de 2026
 */

/**
 * Custom hook used to manage available tab state and shared view logic.
 *
 * This hook centralizes:
 * - Current selected tab/subview.
 * - Search state management.
 * - Export body configuration.
 * - Modification tracking.
 * - Delete trigger handling.
 *
 * @function AvailableTabsApp
 *
 * @returns {Object} Hook response object.
 * @returns {Function} returns.t - Translation function from react-i18next.
 * @returns {string} returns.subView - Current selected subview/tab key.
 * @returns {Function} returns.setSubView - Updates current subview.
 * @returns {Function} returns.setBodyForExport - Updates export body configuration.
 * @returns {string} returns.searchElement - Current search input value.
 * @returns {Function} returns.setSearchElement - Updates search input value.
 * @returns {Function} returns.setSimpleSearch - Updates simple search state.
 * @returns {Function} returns.setSearch - Updates search execution state.
 * @returns {boolean} returns.modified - Indicates whether data has been modified.
 * @returns {Function} returns.setModified - Updates modified state.
 * @returns {boolean} returns.triggerDelete - Indicates whether delete action should be triggered.
 * @returns {Function} returns.setTriggerDelete - Updates delete trigger state.
 */
export const AvailableTabsApp = () => {
    const { t } = useTranslation();

    const [subView, setSubView] = useState(TABS_FA.CUSTOM_ACCESS.key);
    const [bodyForExport, setBodyForExport] = useState(null);
    const [searchElement, setSearchElement] = useState('');
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [modified, setModified] = useState(false);
    const [triggerDelete, setTriggerDelete] = useState(false);

    return {
        t,
        subView,
        setSubView,
        setBodyForExport,
        searchElement,
        setSearchElement,
        setSimpleSearch,
        setSearch,
        modified,
        setModified,
        triggerDelete,
        setTriggerDelete,
    }
}
